function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "BG"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 55,
  cy: 55,
  r: 55,
  fill: "#fff",
  opacity: 0.162
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  "data-name": "Oval",
  cx: 45,
  cy: 45,
  r: 45,
  transform: "translate(10 10)",
  fill: "#fff",
  opacity: 0.182
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-3",
  "data-name": "Oval",
  cx: 35,
  cy: 35,
  r: 35,
  transform: "translate(20 20)",
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "play-button-arrowhead",
  transform: "translate(45 44)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M3.624.489C1.622-.658,0,.282,0,2.588V19.607c0,2.308,1.622,3.248,3.624,2.1L18.5,13.177c2-1.148,2-3.009,0-4.157Z",
  fill: "#0084ff"
}));

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Play_Button",
    "data-name": "Play Button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e7fe669e.svg";
export { ForwardRef as ReactComponent };